import { motion } from 'framer-motion';
import { LucideIcon } from 'lucide-react';

interface FeatureCardProps {
  icon: LucideIcon;
  iconColor?: string;
  title: string;
  description: string;
  list?: string[];
  delay?: number;
}

export const FeatureCard: React.FC<FeatureCardProps> = ({
  icon: Icon,
  iconColor = '#3b82f6',
  title,
  description,
  list,
  delay = 0,
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay }}
      className="
        bg-gradient-to-br from-slate-800/40 to-slate-900/40
        backdrop-blur-xl
        border border-white/10
        rounded-2xl
        p-8
        hover:border-white/20
        transition-all duration-300
        hover:shadow-2xl
      "
    >
      <div className="mb-6">
        <div
          className="inline-flex items-center justify-center w-14 h-14 rounded-xl"
          style={{ backgroundColor: `${iconColor}20` }}
        >
          <Icon size={28} color={iconColor} />
        </div>
      </div>
      <h3 className="text-xl font-semibold text-white mb-3">
        {title}
      </h3>
      <p className="text-slate-300 leading-relaxed mb-4">
        {description}
      </p>
      {list && list.length > 0 && (
        <ul className="space-y-2">
          {list.map((item, index) => (
            <li key={index} className="flex items-start gap-2 text-slate-300 text-sm">
              <span className="text-blue-400 mt-1">✓</span>
              <span>{item}</span>
            </li>
          ))}
        </ul>
      )}
    </motion.div>
  );
};
